import { useMemo } from 'react';

import { useClaim } from '~/components/ClaimContainer';
import useClaimStageConfigurations from '~/components/ClaimStages/hooks/useClaimStageConfigurations';

import type { StageStep } from './types';
import { buildStageSteps } from './utils';

/**
 * The claim's stages as the bar draws them, empty when there is no bar to draw — including while
 * the conductor's stages are still unknown, so the bar never flashes every claim stage first.
 */
const useStageBar = (conductorStageKeys: string[] | undefined): StageStep[] => {
  const { claim } = useClaim({ claimRequired: true });
  const { claimStageConfigurations } = useClaimStageConfigurations();

  return useMemo(
    () => (conductorStageKeys ? buildStageSteps(claimStageConfigurations, conductorStageKeys, claim.stage_key) : []),
    [claimStageConfigurations, conductorStageKeys, claim.stage_key]
  );
};

export default useStageBar;
